import { saveAs } from 'file-saver'
import JSZip from 'jszip'

export const handleDownloadAll = async (filenameForDownloads, imageAnswer) => {
  try {
    var zip = new JSZip()
    zip.folder(filenameForDownloads)
    var img = zip.folder(filenameForDownloads)
    for (const [index, url] of imageAnswer.entries()) {
      const response = await fetch(url)
      const imageType = response.headers.get('Content-Type').split('/')[1]
      const imageBlob = await response.blob()
      img.file(`${filenameForDownloads}-${index + 1}.${imageType}`, imageBlob)
    }
    zip.generateAsync({ type: 'blob' }).then(function (content) {
      saveAs(content, `${filenameForDownloads}.zip`)
    })
  } catch (error) {
    console.error(`Error downloading zip images:`, error)
  }
}

export const handleDownloadImage = async (url, imageName) => {
  try {
    const response = await fetch(url)
    const imageType = response.headers.get('Content-Type').split('/')[1]
    const imageBlob = await response.blob()
    saveAs(imageBlob, `${imageName}.${imageType}`)
  } catch (error) {
    console.error(`Error downloading image from ${url}:`, error)
  }
}
